import { FC, useEffect, useState } from 'react';
import clsx from 'clsx';
import { SearchIcon } from '@heroicons/react/outline';
import { useDebouncedCallback } from 'use-debounce';
import Button from 'components/Button';

interface ITablePatientSearch {
  // totalCount: number;
  search: string;
  onSearch: (search: string) => void;
  setCheckValue?: any;
  // className?: ClassValue;
  theme?: 'default' | 'version-1';
  isPatient?: boolean;
  handleSearchPatient?: () => void;
}

interface ICheckbox {
  label: string;
  value: string;
  onChange: (value: string, isChecked: boolean) => void;
}
const themes = {
  default: {
    searchWrapper: '',
    input: 'rounded-full border-gray-500'
  },
  'version-1': {
    searchWrapper: 'justify-end w-full mr-5',
    input: 'rounded-l-lg'
  }
};

const CheckBox = ({ label, value, onChange }: ICheckbox) => {
  const [isChecked, setIsChecked] = useState<boolean>(false);

  const toggleCheckbox = () => {
    setIsChecked(!isChecked);
    onChange(value, !isChecked);
  };

  return (
    <div className="w-full block">
      <div className="form-checkbox">
        <label className="text-md font-medium leading-5 text-black label-checkbox">
          {label}
          <input type="checkbox" checked={isChecked} onChange={toggleCheckbox} />
          <span className="checkmark error" />
        </label>
      </div>
    </div>
  );
};
const TablePatientSearch: FC<ITablePatientSearch> = ({
  // totalCount,
  search,
  onSearch,
  // className,
  theme = 'default',
  setCheckValue,
  handleSearchPatient
}) => {
  const [value, setValue] = useState<string>(search);
  const [selectedItems, setSelectedItems] = useState<string[]>([]);

  const handleCheckboxChange = (value: string, isChecked: boolean) => {
    if (isChecked) {
      setSelectedItems((prevSelectedItems) => [...prevSelectedItems, value]);
    } else {
      setSelectedItems((prevSelectedItems) => prevSelectedItems.filter((item) => item !== value));
    }
  };

  const handleDebounceSearch = useDebouncedCallback((value: string) => {
    onSearch(value);
  }, 1000);

  useEffect(() => {
    if (selectedItems.length > 0 && value !== '') {
      setCheckValue(selectedItems);
      onSearch(value);
    }
  }, [selectedItems, setCheckValue, onSearch, value]);

  return (
    <>
      <div className={clsx('space-x-3  items-center', themes[theme].searchWrapper)}>
        <div className="flex items-center space-x-8 bg-white p-0rounded-md px-5 py-2">
          <div className="flex space-x-4">
            <CheckBox value="FIRSTNAME" label="Firstname" onChange={handleCheckboxChange} />
            <CheckBox value="LASTNAME" label="Lastname" onChange={handleCheckboxChange} />
            <CheckBox value="EMAIL" label="Email" onChange={handleCheckboxChange} />
            <CheckBox value="PHONE" label="Phone " onChange={handleCheckboxChange} />
          </div>
          <div>
            <div className={clsx('flex border-gray-300 border rounded-md overflow-hidden')}>
              <input
                value={value}
                onChange={(e) => {
                  setValue(e.target.value);
                  handleDebounceSearch(e.target.value);
                }}
                placeholder={`Enter Details...`}
                className="outline-0 px-2"
              />
              <Button variant="borderless" onClick={handleSearchPatient} className="bg-gray-200">
                <SearchIcon className="w-5 h-5 text-hazel-brown-100" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TablePatientSearch;
